import { FormattedMessage } from 'react-intl';

import { Link } from 'react-router-dom';

import {
  domain,
  version,
  statusPageUrl,
  profile_directory as canProfileDirectory,
  termsOfServiceEnabled,
  software,
} from 'flavours/glitch/initial_state';

import classes from './link_footer.module.scss';

export const LinkFooter: React.FC<{
  context?: 'default' | 'multi-column' | 'about';
}> = ({ context = 'default' }) => {
  const multiColumn = context === 'multi-column';

  return (
    <footer className={classes.wrapper} data-context={context}>
      <section>
        <h2 className={classes.heading}>{`${domain}:`}</h2>
        <ul className={classes.list}>
          <li>
            <Link to='/about' target={multiColumn ? '_blank' : undefined}>
              <FormattedMessage
                id='footer.about_this_server'
                defaultMessage='About'
              />
              <span className='sr-only'> {domain}</span>
            </Link>
          </li>
          {statusPageUrl && (
            <li>
              <a href={statusPageUrl} target='_blank' rel='noopener'>
                <FormattedMessage id='footer.status' defaultMessage='Status' />
              </a>
            </li>
          )}
          {canProfileDirectory && (
            <li>
              <Link to='/directory'>
                <FormattedMessage
                  id='footer.directory'
                  defaultMessage='Profiles directory'
                />
              </Link>
            </li>
          )}
          <li>
            <Link
              to='/privacy-policy'
              target={multiColumn ? '_blank' : undefined}
              rel='privacy-policy'
            >
              <FormattedMessage
                id='footer.privacy_policy'
                defaultMessage='Privacy policy'
              />
            </Link>
          </li>
          {termsOfServiceEnabled && (
            <li>
              <Link
                to='/terms-of-service'
                target={multiColumn ? '_blank' : undefined}
                rel='terms-of-service'
              >
                <FormattedMessage
                  id='footer.terms_of_service'
                  defaultMessage='Terms of service'
                />
              </Link>
            </li>
          )}
        </ul>
      </section>
      <section>
        <h2 className={classes.heading}>
          {(() => {
            let softwareDisplayName = 'General Fediverse Software';
            if (software) {
              const sw = software.toLowerCase();
              if (sw === 'mastodon') {
                softwareDisplayName = 'Mastodon';
              } else if (sw === 'pleroma') {
                softwareDisplayName = 'Pleroma';
              } else if (sw === 'gotosocial') {
                softwareDisplayName = 'GotoSocial';
              } else {
                softwareDisplayName =
                  software.charAt(0).toUpperCase() + software.slice(1);
              }
            }
            return `${softwareDisplayName}:`;
          })()}
        </h2>
        <ul className={classes.list}>
          <li className={classes.version}>v{version}</li>
        </ul>
      </section>
    </footer>
  );
};
